import http from 'shared/utils/http';
import settings from 'shared/settings';
import openPopup from 'shared/utils/open-popup';


export default {
  paypal(options) {
    openPopup(http.buildUrl(`${settings.hosts.paypal}vod/pp/start`, options));
  },
  cancelSubscription(channelId, siteUrl, instance) {
    openPopup(http.buildUrl(`${settings.hosts.paypal}vod/pp/subscribe/cancel_profile`, {
      type: 'subscription',
      channelId,
      ref: siteUrl,
      instance,
    }));
  },
};



// WEBPACK FOOTER //
// ./src/widget/utils/payments.js